import ApplicationController from './application_controller';

/**
 * Shows the `Impulse::DialogComponent` when clicked on the button element.
 *
 * @example
 *
 * <button type="button" data-controller="dialog" data-dialog-id-value="dialog-id">
 *   Open dialog
 * </button>
 *
 * Next, add the dialog markup.
 *
 * <%= render(Impulse::DialogComponent.new(id: "dialog-id", title: "My dialog")) %>
 */
export default class extends ApplicationController {
  static values = { id: String };

  initialize() {
    this.showDialog = this.showDialog.bind(this);
  }

  connect() {
    this.element.addEventListener('click', this.showDialog);
  }

  disconnect() {
    this.element.removeEventListener('click', this.showDialog);
  }

  showDialog() {
    const dialog = document.getElementById(this.idValue);
    if (dialog?.open) return;
    dialog?.show();
    this.dispatch('shown', { detail: { dialog, relatedTarget: this.element } });
  }
}
